import {
  getFirestore,
  doc,
  setDoc,
  getDocs,
  query,
  where,
  collection,
} from "firebase/firestore";

import { db } from "../../firebase";
import Cookies from "js-cookie";

export const Createprojects = async (data) => {
  if (!data?.puid) {
    return { success: false, error: "Missing pUID for user document." };
  }

  if (!data?.projectname) {
    return { success: false, error: "Missing project name." };
  }

  try {
    // Check if a similar unread message already exists
    const checkQuery = query(
      collection(db, "projects"),
      where("adminguid", "==", Cookies.get("adminguid")),
      where("projectname", "==", data.projectname),
    );
    const checkSnap = await getDocs(checkQuery);
    if (!checkSnap.empty) {
      return { success: false, error: "Already project name." };
    }
let indexstage = 1;
const indexstageQuery = query(
  collection(db, "projects"),
  where("adminguid", "==", Cookies.get("adminguid")), 
);
const indexstageSnap = await getDocs(indexstageQuery);
if (!indexstageSnap.empty) {
  indexstage = indexstageSnap.size + 1;
}

    const docRef = doc(db, "projects", data.puid);
    const timestamp = new Date();
    const savequery = {
      ...data,
      guid: Cookies.get("guid") || "",
       adminguid: Cookies.get("adminguid") || "",
      ip: Cookies.get("ipaddress") || "",
      device: typeof navigator !== "undefined" ? navigator.userAgent : "",
      date_time: timestamp,
      update_date_time: timestamp,
      due_date_time: timestamp,
      save: false,
      status: true,
      archived: false,
      indexstage:indexstage,
      // ip:Cookies.get("ipaddres") || "",
      //   city: Cookies.get("city") || "",
      // city: Cookies.get("city") || "",
      // postcode: Cookies.get("postcode") || "",
      state: Cookies.get("state") || "",
      country: Cookies.get("country") || "",
    };

    await setDoc(docRef, savequery);
    return { success: true };

  } catch (err) {
    console.error("Error saving message system:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
